import { render, staticRenderFns } from "./Welcometo.vue?vue&type=template&id=9e09d544&scoped=true"
import script from "./Welcometo.vue?vue&type=script&setup=true&lang=js"
export * from "./Welcometo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Welcometo.vue?vue&type=style&index=0&id=9e09d544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e09d544",
  null
  
)

export default component.exports